module.exports = __webpack_public_path__ + "static/media/wavy_blob_green.eeb5625a.svg";